import {useEffect} from 'react';

export const useReloadOnPageshow = () => {
  useEffect(() => {
    const handlePageshow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', handlePageshow);
    return () => window.removeEventListener('pageshow', handlePageshow);
    /* eslint-disable react-hooks/exhaustive-deps*/
  }, []);
};
